import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';

import { changeSpace } from '@app/actions/navigation';
import changeClassroomAvatar from '@core/actions/classRoom/avatar';
import * as selectors from '@core/selectors/spaces';
import * as classRoomSelectors from '@core/selectors/classroom';
import * as userSelectors from '@core/selectors/user';
import SpaceSelector from './SpaceSelector';

const selectSpacesData = createStructuredSelector({
  space: selectors.space,
  spacesData: selectors.spacesData,
  isAdmin: classRoomSelectors.isInstructor,
  isLoading: classRoomSelectors.isChangingAvatar,
  userRoles: userSelectors.getUserRoles,
});

const excludeSpace =
  (currentSpaceId) =>
  ({ objectId, isStaff }) =>
    objectId === currentSpaceId || isStaff;

const mapStateToProps = createSelector(
  selectSpacesData,
  ({ space, spacesData, isAdmin, isLoading, userRoles }) => ({
    currentSpaceId: space.current,
    currentSpace: selectors.spaceById(spacesData, space.current) || {},
    isAdmin,
    userRoles,
    spaces: selectors.alphabeticallySorted(spacesData).reduce((spaces, s) => {
      if (excludeSpace(space.current)(s)) {
        return spaces;
      }
      return [
        ...spaces,
        {
          id: s.objectId,
          name: s.name,
          archived: s.archived,
        },
      ];
    }, []),
    isLoading,
  })
);

const mapDispatchToProps = (dispatch) => ({
  onSpaceSelect: (spaceId) => dispatch(changeSpace(spaceId)),
  onSpaceImageChange: (file) => dispatch(changeClassroomAvatar(file)),
});

const mergeProps = (
  { currentSpaceId, ...otherStateProps },
  { ...otherDispatchProps },
  ownProps
) => ({
  ...otherStateProps,
  ...otherDispatchProps,
  ...ownProps,
});

const SpaceSelectorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SpaceSelector);

export default SpaceSelectorContainer;
